import AdminPageHeader from '../../../components/admin/AdminPageHeader';
import Loading from '../../../components/Loading';
import LumaDialog from '../../../components/admin/LumaDialog';
import PagosModal from '../pagos/PagosModal';
import PagosModalHistorial from '../pagos/PagosModalHistorial';
import AsistenciaReservaPanel from '../../../components/posCita/AsistenciaReservaPanel';
import TemporizadorReservaPanel from '../../../components/posCita/TemporizadorReservaPanel';
import DocumentoCobroPreview, {FormatoDocumento} from '../../../components/posCita/DocumentoCobroPreview';
import FacturaReserva from '../../../components/posCita/FacturaReserva';
import ModalAgregarClientesAsociados from '../../../components/posCita/ModalAgregarClientesAsociados';
import CustomerGiftHoursPanel from './CustomerGiftHoursPanel';
import {Cliente,fetchClientes,agregarClientesAsociados} from '../../../services/citasService';
import { OperadorGrantRow, OperadorPinDialog, useOperadorGrant } from '../../../components/pos/OperadorPinDialog';
import {isVirtualOffice} from '../../../utils/reservationPresence';
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchCitaById, patchCita, Cita, fetchEspacioServicios, fetchPrecioPlanesServicios, fetchCategories } from '../../../services/citasService';
import {
    Calendar, User, Building2, Tag, Users,
    CheckCircle2, XCircle, AlertCircle, ChevronLeft, Printer,
    Download, Edit, Trash2, Mail, CreditCard, CalendarDays, Clock as ClockIcon, Receipt, UserCheck, FileText, ArrowLeft,
    Package, MapPin, Layers, Sparkles, ShieldCheck, Save
} from 'lucide-react';

import CancelarReservaPanel, { bloqueoCancelacion } from '../../../components/posCita/CancelarReservaPanel';
import ProductosReservaDetalle from '../../../components/posCita/ProductosReservaDetalle';
import TrazabilidadReserva from '../../../components/posCita/TrazabilidadReserva';

const DetallesReservaPage = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const identity=useRef(Number(id));identity.current=Number(id);
    const [panel,setPanel]=useState<'asistencia'|'temporizador'|'documento'|'pago'|'historial'|null>(null);
    const [formato,setFormato]=useState<FormatoDocumento>('rollo');
    const [candidatos,setCandidatos]=useState<Cliente[]>([]);
    const [asociadosOpen,setAsociadosOpen]=useState(false);
    const [actionError,setActionError]=useState('');
    const [revision,setRevision]=useState(0);
    const [cita, setCita] = useState<Cita | null>(null);
    const operador = useOperadorGrant(cita?.sesion_pos ?? null);
    const [cancelando, setCancelando] = useState(false);
    const [cancelacionExitosa, setCancelacionExitosa] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [espacioInfo, setEspacioInfo] = useState<any>(null);
    const [precioPlanInfo, setPrecioPlanInfo] = useState<any>(null);
    const [categoriaInfo, setCategoriaInfo] = useState<any>(null);
    const [loadingDetails, setLoadingDetails] = useState(true);

    // Estados para control de ingreso, salida y limpieza
    const [isEditingObservaciones, setIsEditingObservaciones] = useState(false);
    const [obsIngreso, setObsIngreso] = useState('');
    const [obsSalida, setObsSalida] = useState('');
    const [limpIngreso, setLimpIngreso] = useState(true);
    const [limpSalida, setLimpSalida] = useState(true);
    const [isSavingObs, setIsSavingObs] = useState(false);
    const [obsSuccessMsg, setObsSuccessMsg] = useState<string | null>(null);

    // --- PALETA DE COLORES COMARCA ---
    const theme = {
        primaryAction: 'var(--ad-primary, #3564db)',  // Magenta
        corporate: 'var(--ad-primary-dark, #8f1f64)',      // Vino
        highlightText: '#ea8406',  // Naranja Oscuro
        highlightBg: '#ffd97c',    // Amarillo Claro
        blue: 'var(--ad-secondary, #3564db)',           // Azul
        teal: 'var(--ad-secondary, #92b1ed)',           // Turquesa
    };

    useEffect(()=>{
      let active=true;const requested=Number(id);
      setPanel(null);setAsociadosOpen(false);setActionError('');setCandidatos([]);setCita(null);setIsLoading(true);setLoadingDetails(true);setError(null);
      if(!Number.isSafeInteger(requested)||requested<=0){setError('No se indicó una reserva válida.');setIsLoading(false);setLoadingDetails(false);return()=>{active=false;};}
      const load=async()=>{try{
        const next=await fetchCitaById(requested);if(!active)return;
        const [spaces,prices,categories]=await Promise.allSettled([next.espacio_servicio?fetchEspacioServicios():Promise.resolve([]),fetchPrecioPlanesServicios(),next.categoria?fetchCategories():Promise.resolve([])]);
        if(!active)return;setCita(next);setObsIngreso(next.observaciones_ingreso||'');setObsSalida(next.observaciones_salida||'');setLimpIngreso(next.limpieza_ingreso??true);setLimpSalida(next.limpieza_salida??true);
        setEspacioInfo(spaces.status==='fulfilled'?spaces.value.find(e=>e.id===next.espacio_servicio)||null:null);setPrecioPlanInfo(prices.status==='fulfilled'?prices.value.find(p=>p.id===next.precio_plan_servicio)||null:null);setCategoriaInfo(categories.status==='fulfilled'?categories.value.find((c:any)=>c.id===next.categoria)||null:null);
      }catch{if(active)setError('No se pudo cargar el detalle de la reserva.');}finally{if(active){setIsLoading(false);setLoadingDetails(false);}}};
      void load();return()=>{active=false;};
    },[id]);

    const getEstadoBadgeStyles = (estado: string) => {
        const base = "inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-semibold tracking-wide border";

        switch (estado.toLowerCase()) {
            case 'confirmada':
            case 'completada':
                return `${base} bg-green-50 text-green-700 border-green-200`;
            case 'pendiente':
                return `${base} bg-yellow-50 text-yellow-700 border-yellow-200`;
            case 'cancelada':
                return `${base} bg-red-50 text-red-700 border-red-200`;
            case 'en_proceso':
                return `${base} bg-blue-50 text-blue-700 border-blue-200`;
            default:
                return `${base} bg-gray-50 text-gray-600 border-gray-200`;
        }
    };

    const getEstadoPagoBadgeStyles = (estadoPago: string) => {
        const base = "inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-semibold tracking-wide border";

        switch (estadoPago.toLowerCase()) {
            case 'pagado':
            case 'completado':
                return `${base} bg-green-50 text-green-700 border-green-200`;
            case 'parcial':
                return `${base} bg-blue-50 text-blue-700 border-blue-200`;
            case 'pendiente':
            default:
                return `${base} bg-yellow-50 text-yellow-700 border-yellow-200`;
        }
    };

    // FUNCIONES CORREGIDAS PARA MANEJAR ZONA HORARIA
    const parseDateString = (dateString?: string | null): Date | null => {
        if (!dateString) return null;

        // Si la fecha viene con Z (UTC), mantenerla como UTC
        if (dateString.endsWith('Z')) {
            return new Date(dateString);
        }

        // Si no tiene Z, asumir que está en UTC y agregar 'Z' para forzar interpretación UTC
        // Esto previene que el navegador la interprete como hora local
        return new Date(dateString.includes('T') ? dateString + 'Z' : dateString + 'T00:00:00Z');
    };

    const formatDate = (dateString?: string | null) => {
        if (!dateString) return 'No programada';
        try {
            const date = parseDateString(dateString);
            if (!date || isNaN(date.getTime())) return 'Fecha inválida';

            // Usar UTC para evitar cambios por zona horaria
            return date.toLocaleDateString('es-ES', {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long'
            });
        } catch (error) {
            /* Browser diagnostics omitted. */
            return 'Fecha inválida';
        }
    };

    const formatTime = (timeString?: string | null) => {
        if (!timeString) return 'Sin hora';
        try {
            return timeString.substring(0, 5); // Formato HH:MM
        } catch (error) {
            return 'Hora inválida';
        }
    };

    const formatDateRange = (startDate?: string | null, endDate?: string | null) => {
        if (!startDate) return 'No programada';

        const start = parseDateString(startDate);
        if (!start || isNaN(start.getTime())) return 'Fecha inválida';

        // Formatear fecha de inicio en UTC
        const startFormatted = start.toLocaleDateString('es-ES', {
            timeZone: 'UTC',
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });

        if (!endDate) return startFormatted;

        const end = parseDateString(endDate);
        if (!end || isNaN(end.getTime())) return startFormatted;

        // Formatear fecha de fin en UTC
        const endFormatted = end.toLocaleDateString('es-ES', {
            timeZone: 'UTC',
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });

        return `${startFormatted} - ${endFormatted}`;
    };

    // CAMBIADO: Función para formatear moneda con "Bs" en lugar de "BOB"
    const formatCurrency = (amount: number) => {
        return `Bs ${amount.toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    const getEstadoIcon = (estado: string) => {
        switch (estado.toLowerCase()) {
            case 'confirmada':
            case 'completada':
                return <CheckCircle2 className="h-5 w-5" />;
            case 'cancelada':
                return <XCircle className="h-5 w-5" />;
            case 'pendiente':
            case 'en_proceso':
                return <AlertCircle className="h-5 w-5" />;
            default:
                return <AlertCircle className="h-5 w-5" />;
        }
    };

    const handlePrint = () => {
        window.print();
    };

    const handleSaveObservaciones = async () => {
        if (!cita || cita.id!==identity.current) return;
        if (!operador.token) { operador.openDialog(); return; }
        setIsSavingObs(true);
        try {
            const updated = await patchCita(cita.id, {
                observaciones_ingreso: obsIngreso,
                observaciones_salida: obsSalida,
                limpieza_ingreso: limpIngreso,
                limpieza_salida: limpSalida
            }, operador.token);
            if(cita.id!==identity.current)return;
            setCita(prev => prev ? { ...prev, ...updated } : null);
            setIsEditingObservaciones(false);
            setObsSuccessMsg('Observaciones y estado de limpieza actualizados con éxito');
            setTimeout(() => setObsSuccessMsg(null), 3500);
        } catch (err) {
            /* Browser diagnostics omitted. */
        } finally {
            setIsSavingObs(false);
        }
    };

    // Función para debug: mostrar fecha en diferentes formatos
    const debugDate = (dateString?: string | null) => {
        if (!dateString) return null;
        const date = parseDateString(dateString);
        if (!date) return null;

        return {
            original: dateString,
            utc: date.toISOString(),
            local: date.toLocaleString('es-ES'),
            day: date.getUTCDate()
        };
    };

    if (isLoading || loadingDetails || (cita && cita.id!==Number(id))) {
        return (
            <Loading text="Cargando detalle de reserva…"/>
        );
    }

    if (error || !cita) {
        return (
            <div className="min-h-screen bg-gray-50/50 flex items-center justify-center">
                <div className="text-center">
                    <div className="mx-auto h-16 w-16 rounded-full bg-red-50 flex items-center justify-center mb-4">
                        <XCircle className="h-8 w-8 text-red-500" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Error al cargar la reserva</h3>
                    <p className="text-gray-600 mb-6">{error || "La reserva no existe"}</p>
                    <button
                        onClick={() => navigate('/reservas')}
                        className="px-4 py-2 bg-[#8f1f64] text-white rounded-lg hover:bg-[#3564db] transition-colors flex items-center gap-2 mx-auto"
                    >
                        <ChevronLeft className="h-4 w-4" />
                        Volver a reservas
                    </button>
                </div>
            </div>
        );
    }

    const bloqueo = bloqueoCancelacion(cita);
    const abrirCancelacion = () => {
        setCancelando(true);
        window.setTimeout(() => document.getElementById('cancelacion-reserva')?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 0);
    };

    // Debug: mostrar información de fechas
    /* Browser diagnostics omitted. */
    /* Browser diagnostics omitted. */

    const recargar=async()=>{const requested=cita.id;try{const actual=await fetchCitaById(requested);if(requested!==identity.current)return;setCita(actual);setRevision(v=>v+1);}catch{setActionError('No se pudo actualizar la reserva.');}};
    const abrirAsociados=async()=>{setActionError('');if(!operador.token){operador.openDialog();return;}try{setCandidatos(await fetchClientes());setAsociadosOpen(true);}catch{setActionError('No se pudieron consultar los clientes.');}};
    const agregarAsociados=async(ids:number[])=>{if(!operador.token){operador.openDialog();return;}try{const userIds=candidatos.filter(c=>ids.includes(c.id)&&c.usuario&&c.usuario.id!==cita.cliente).map(c=>c.usuario!.id);await agregarClientesAsociados(cita.id,userIds,operador.token);await recargar();setAsociadosOpen(false);}catch{setAsociadosOpen(false);setActionError('No se pudieron agregar los participantes. Revisa la capacidad y los permisos de la caja.');}};
    const clienteNombre=`${cita.cliente_info?.first_name||''} ${cita.cliente_info?.last_name||''}`.trim()||'Cliente sin asignar';
    const servicioNombre=cita.servicio_info?.nombre||precioPlanInfo?.servicio_nombre||'Servicio';
    const planNombre=cita.plan_info?.plan_nombre||precioPlanInfo?.plan_nombre||'Plan de la reserva';
    const saldo=Math.max(0,Number(cita.total)-Number(cita.monto_pagado||0));
    return <div data-admin-page="true" className="luma-reservation-detail">
      <AdminPageHeader eyebrow="PUNTO DE VENTA / CO MARCA GROUP" title="Detalle de reserva" description="Consulta y gestiona la información de tu coworking." actions={<button type="button" className="vx-button vx-button-secondary" onClick={()=>navigate('/reservas')}>Volver a órdenes</button>}/>
      {actionError&&<p role="alert" className="luma-feedback">{actionError}</p>}
      {cancelacionExitosa&&<p role="status" className="luma-feedback">Reserva cancelada correctamente. El horario quedó disponible.</p>}
      <div className="luma-detail-layout"><div className="luma-detail-main">
        <section className="luma-resource-panel"><div className="luma-panel-heading"><div><p className="vx-section-kicker">RESERVA #{cita.codigo||cita.id}</p><h3>{clienteNombre}</h3></div><span className="luma-badge success">{cita.estado}</span></div>
          <dl className="luma-reservation-facts"><div><dt>Servicio</dt><dd>{servicioNombre}</dd></div><div><dt>Plan</dt><dd>{planNombre}</dd></div><div><dt>Espacio</dt><dd>{cita.espacio_info?.nombre||espacioInfo?.espacio_nombre||'Sin espacio físico'}</dd></div><div><dt>Agenda</dt><dd>{formatDateRange(cita.fecha_inicio,cita.fecha_fin)} · {formatTime(cita.hora_inicio)}–{formatTime(cita.hora_fin)}</dd></div></dl>
          {isVirtualOffice(cita)&&<p className="cowork-virtual-note">Oficina virtual · sus períodos y beneficios se gestionan sin asistencia presencial.</p>}<div className="luma-resource-toolbar"><button type="button" className="vx-button vx-button-secondary" onClick={()=>navigate(`/reservas/editar/${cita.id}`)}>Editar reserva</button>{!isVirtualOffice(cita)&&<button type="button" className="vx-button vx-button-secondary" onClick={()=>setPanel('asistencia')}>Registrar asistencia</button>}{(cita.usa_temporizador||cita.temporizador_info)&&<button type="button" className="vx-button vx-button-secondary" onClick={()=>setPanel('temporizador')}>Temporizador</button>}<button type="button" className="luma-text-button" disabled={!!bloqueo} title={bloqueo||undefined} onClick={abrirCancelacion}>Cancelar</button></div>
          {bloqueo&&<p className="luma-detail-note">{bloqueo}</p>}
          <OperadorGrantRow grant={operador.grant} onIdentify={operador.openDialog}/>
          <div id="cancelacion-reserva">{cancelando&&<CancelarReservaPanel key={cita.id} cita={cita} token={operador.token} onIdentify={operador.openDialog} onClose={()=>setCancelando(false)} onSuccess={actualizada=>{setCita(actualizada);setCancelando(false);setCancelacionExitosa(true);}}/>}</div>
        </section>
        <section className="luma-resource-panel"><div className="luma-panel-heading"><h3>Participantes y beneficios</h3><button type="button" className="vx-button vx-button-secondary" onClick={abrirAsociados}>+ Agregar asociados</button></div><div className="luma-participant-row"><span className="luma-record-avatar">{clienteNombre.slice(0,2)}</span><div><strong>{clienteNombre}</strong><small>Titular · {servicioNombre}</small></div></div>{cita.clientes_asociados_info?.map(c=><div key={c.id} className="luma-participant-row"><span className="luma-record-avatar">{c.first_name?.[0]}{c.last_name?.[0]}</span><div><strong>{c.first_name} {c.last_name}</strong><small>Participante asociado</small></div></div>)}{cita.cliente_info?.id&&<CustomerGiftHoursPanel customerUserId={cita.cliente_info.id} sucursalId={cita.sucursal||0}/>}</section>
        <section className="luma-resource-panel"><h3>Trazabilidad</h3><TrazabilidadReserva key={revision} citaId={cita.id}/></section>
        <section className="luma-resource-panel"><details><summary>Observaciones de la reserva y limpieza</summary><form className="luma-movement-form" onSubmit={e=>{e.preventDefault();void handleSaveObservaciones();}}><label>Observaciones de ingreso<textarea value={obsIngreso} onChange={e=>setObsIngreso(e.target.value)} disabled={isSavingObs}/></label><label>Observaciones de salida<textarea value={obsSalida} onChange={e=>setObsSalida(e.target.value)} disabled={isSavingObs}/></label><label><input type="checkbox" checked={limpIngreso} onChange={e=>setLimpIngreso(e.target.checked)} disabled={isSavingObs}/> Limpieza al ingreso</label><label><input type="checkbox" checked={limpSalida} onChange={e=>setLimpSalida(e.target.checked)} disabled={isSavingObs}/> Limpieza a la salida</label>{obsSuccessMsg&&<p role="status">{obsSuccessMsg}</p>}<button type="submit" className="vx-button vx-button-primary" disabled={isSavingObs}>Guardar observaciones</button></form></details></section><ProductosReservaDetalle cita={cita} showEmpty/>
      </div><aside className="luma-detail-aside"><section className="luma-resource-panel"><p className="vx-section-kicker">ESTADO DE CUENTA</p><h3>Resumen de cobro</h3><dl className="luma-account-lines"><div><dt>Servicio</dt><dd>{formatCurrency(Number(cita.subtotal??cita.total))}</dd></div><div><dt>Descuento</dt><dd>{formatCurrency(Number(cita.descuento_directo||0)+Number(cita.descuento_servicio||0))}</dd></div><div><dt>Pagado</dt><dd>{formatCurrency(Number(cita.monto_pagado||0))}</dd></div><div><dt>Total de la reserva</dt><dd>{formatCurrency(Number(cita.total))}</dd></div><div className="luma-account-total"><dt>Saldo pendiente</dt><dd>{formatCurrency(saldo)}</dd></div></dl><div className="luma-account-actions"><button type="button" className="vx-button vx-button-primary" disabled={!cita.sesion_pos||!saldo||!!cita.temporizador_info} onClick={()=>setPanel('pago')}>Registrar pago</button>{!cita.sesion_pos&&<button type="button" className="luma-text-button" onClick={()=>navigate('/pos-list')}>Seleccionar caja para el cobro</button>}<button type="button" className="vx-button vx-button-secondary" onClick={()=>setPanel('historial')}>Historial de pagos</button><button type="button" className="vx-button vx-button-secondary" onClick={()=>setPanel('documento')}>Comprobante / factura</button></div></section></aside></div>
      <OperadorPinDialog open={operador.dialogOpen} sesionId={cita.sesion_pos??null} onClose={operador.closeDialog} onGrant={operador.install}/>
      <LumaDialog open={panel==='asistencia'} title="Registrar asistencia" onClose={()=>setPanel(null)}><AsistenciaReservaPanel cita={cita} sessionId={cita.sesion_pos||undefined} operatorToken={operador.token} revision={revision} onChanged={()=>{void recargar();}}/></LumaDialog>
      <LumaDialog open={panel==='temporizador'} title="Control del temporizador" onClose={()=>setPanel(null)}>{cita.sesion_pos&&<><OperadorGrantRow grant={operador.grant} onIdentify={()=>{setPanel(null);operador.openDialog();}}/><TemporizadorReservaPanel cita={cita} sesionPosId={cita.sesion_pos} operadorToken={operador.token} onActualizada={setCita} onFinalizada={actualizada=>{setCita(actualizada);setPanel(null);setRevision(v=>v+1);}}/></>}</LumaDialog>
      <LumaDialog open={panel==='documento'} title="Comprobante / factura" onClose={()=>setPanel(null)} wide><DocumentoCobroPreview cita={cita} total={Number(cita.total)} pagado={Number(cita.monto_pagado||0)} formato={formato} onFormato={setFormato}/><FacturaReserva citaId={cita.id} formatoInicial={formato}/></LumaDialog>
      {cita.sesion_pos&&<PagosModal isOpen={panel==='pago'} onClose={()=>setPanel(null)} citaId={cita.id} montoCita={Number(cita.total)} montoPagado={Number(cita.monto_pagado||0)} sesionPosId={cita.sesion_pos} operadorToken={operador.token} onIdentifyOperator={()=>{setPanel(null);operador.openDialog();}} onPagoSuccess={()=>{setPanel(null);void recargar();}}/>}
      <PagosModalHistorial isOpen={panel==='historial'} onClose={()=>setPanel(null)} citaId={cita.id}/>
      <ModalAgregarClientesAsociados isOpen={asociadosOpen} onClose={()=>setAsociadosOpen(false)} onAgregar={ids=>{void agregarAsociados(ids);}} clientes={candidatos} clientesExcluir={candidatos.filter(c=>c.usuario&&(c.usuario.id===cita.cliente||cita.clientes_asociados?.includes(c.usuario.id))).map(c=>c.id)} capacidadMaxima={espacioInfo?.cantidad_personas?Math.max(0,espacioInfo.cantidad_personas-1-(cita.clientes_asociados?.length||0)):undefined}/>
    </div>;
};
export default DetallesReservaPage;
